import React, { useEffect, useState } from "react";
import {
  Container,
  Table,
  Spinner,
  Badge,
  Card,
  Row,
  Col,
  Modal,
  Button,
} from "react-bootstrap";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import "./MyOrderInfo.css";

export default function MyOrderInfo({ userPhoneNumber }) {
  const [pendingOrders, setPendingOrders] = useState([]);
  const [completedOrders, setCompletedOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deliveryLocation, setDeliveryLocation] = useState(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCCyX0p7CT8yKWdAJFeEFsutCGON58bajw",
  });

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        if (!userPhoneNumber) return;

        const response = await fetch(
          `https://yaasaai.com/myphpapi/get-user-orders.php?action=get-user-orders&phoneNumber=${encodeURIComponent(
            userPhoneNumber
          )}`
        );

        if (response.ok) {
          const contentType = response.headers.get("Content-Type");
          if (!contentType.includes("application/json")) {
            throw new Error("Expected JSON response, but got something else.");
          }
          const data = await response.json();
          if (data.orders) {
            const pending = data.orders.filter(
              (order) => order.status === "not done"
            );
            const completed = data.orders.filter(
              (order) => order.status === "delivered done"
            );
            setPendingOrders(pending);
            setCompletedOrders(completed);
          } else {
            setPendingOrders(data.grouped_pending || []);
            setCompletedOrders(data.grouped_completed || []);
          }
        } else {
          const errorText = await response.text();
          throw new Error(
            `Failed to fetch orders: ${response.status} ${errorText}`
          );
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [userPhoneNumber]);

  const fetchDeliveryLocation = async (orderid) => {
    const apiUrl = `https://yaasaai.com/myphpapi/get-delivery-location.php?orderid=${encodeURIComponent(
      orderid
    )}`;

    try {
      const response = await fetch(apiUrl);
      const contentType = response.headers.get("Content-Type") || "";

      if (!response.ok) {
        const errorText = await response.text();
        console.error(`HTTP error ${response.status}: ${errorText}`);
        alert("Failed to fetch delivery location. Please try again later.");
        return;
      }

      if (!contentType.includes("application/json")) {
        const errorText = await response.text();
        console.error("Unexpected response format:", errorText);
        alert("Unexpected response format from server.");
        return;
      }

      const data = await response.json();

      if (data?.location?.lat && data?.location?.lng) {
        setDeliveryLocation({
          lat: parseFloat(data.location.lat),
          lng: parseFloat(data.location.lng),
        });
        console.log("Delivery location set:", data.location);
      } else {
        console.warn("No valid location data found in response.");
        alert("No delivery location found for this order.");
      }
    } catch (error) {
      console.error("Error fetching delivery location:", error);
      alert("An error occurred while fetching delivery location.");
    }
  };

  const handleViewDetails = async (order) => {
    setSelectedOrder(order);
    setShowModal(true);
    setDetailsLoading(true);
    setDeliveryLocation(null);

    const custid = order.cust_id || userPhoneNumber;
    const orderid = order.orderid;

    if (!custid || !orderid) {
      alert("Phone number or Order ID is missing!");
      setDetailsLoading(false);
      return;
    }

    try {
      const response = await fetch(
        `https://yaasaai.com/myphpapi/get-order-detail.php?action=get-order-details&phoneNumber=${encodeURIComponent(
          custid
        )}&orderid=${encodeURIComponent(orderid)}&status=${encodeURIComponent(
          order.status
        )}`
      );

      const contentType = response.headers.get("Content-Type");

      if (!response.ok || !contentType.includes("application/json")) {
        alert("Failed to load order details. Please try again.");
        return;
      }

      const data = await response.json();
      setOrderDetails(data);
      console.log("orderdetails dtat", data);
    } catch (error) {
      alert("An error occurred. Please try again later.");
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleCloseModal = () => {
    setSelectedOrder(null);
    setOrderDetails(null);
    setShowModal(false);
    setDeliveryLocation(null);
  };

  return (
    <Container fluid className="mt-4">
      <h2 className="mb-3 text-center">My Orders</h2>
      <p className="text-center">
        <strong>Phone Number:</strong> {userPhoneNumber || "Not Available"}
      </p>

      {loading ? (
        <div className="text-center">
          <Spinner animation="border" />
        </div>
      ) : error ? (
        <div className="text-center text-danger">
          <p>{error}</p>
        </div>
      ) : (
        <Row>
          <Col xs={12} md={6}>
            <OrderSection
              title="Pending Orders"
              orders={pendingOrders}
              variant="warning"
              handleViewDetails={handleViewDetails}
            />
          </Col>
          <Col xs={12} md={6}>
            <OrderSection
              title="Completed Orders"
              orders={completedOrders}
              variant="success"
              handleViewDetails={handleViewDetails}
            />
          </Col>
        </Row>
      )}
      {/* this is order details model */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Order Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {detailsLoading ? (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          ) : orderDetails ? (
            <>
              <div className="container-fluid">
                <div className="row mb-1">
                  <div className="col-md-6 mb-1">
                    <p style={{ color: "Grey", fontWeight: "bold" }}>
                      <strong>Customer :</strong> {orderDetails.customer?.name}{" "}
                      ({orderDetails.customer?.phonenumber})
                    </p>

                    {/* <Button
                      variant="info"
                      size="sm"
                      onClick={() =>
                        fetchDeliveryLocation(selectedOrder.orderid)
                      }
                    >
                      Track Delivery Location
                    </Button> */}
                  </div>

                  {/* Small map section on the right */}
                  <div className="col-md-6">
                    {deliveryLocation && isLoaded && (
                      <div
                        style={{
                          height: "200px",
                          width: "100%",
                          borderRadius: "20px",
                          border: "1px solid grey",
                          overflow: "hidden",
                          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                        }}
                      >
                        <GoogleMap
                          center={deliveryLocation}
                          zoom={16}
                          mapContainerStyle={{ width: "100%", height: "100%" }}
                        >
                          <Marker position={deliveryLocation} />
                        </GoogleMap>
                      </div>
                    )}
                  </div>
                </div>

                {orderDetails.shops?.map((shop, index) => (
                  <div key={index} className="mb-4">
                    <h6 className="text-success">{shop.shop_name}</h6>
                    <Table bordered size="sm" responsive>
                      <thead>
                        <tr>
                          <th>Item</th>
                          <th>Rate</th>
                          <th>Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        {shop.items?.map((item, idx) => (
                          <tr key={idx}>
                            <td>{item.veg_name}</td>
                            <td>₹ {item.veg_rate}</td>
                            <td>{item.veg_quantity}</td>
                          </tr>
                        ))}
                        <tr className="td_total">
                          <td style={{ color: "goldenrod" }}>Shop Total</td>
                          <td colSpan={2} style={{ color: "goldenrod" }}>
                            ₹ {shop.total}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                ))}

                <hr />
                <div className="row">
                  <div className="col-md-4">
                    <p style={{ color: "black", fontWeight: "bold" }}>
                      <strong>Overall Total : </strong> ₹
                      {orderDetails.overall_total ?? "N/A"}
                    </p>
                  </div>
                  <div className="col-md-4">
                    <p style={{ color: "black", fontWeight: "bold" }}>
                      <strong>Delivery Charge : </strong> ₹
                      {orderDetails.delivery_charge ?? "N/A"}
                    </p>
                  </div>
                  <div className="col-md-4">
                    <p style={{ color: "black", fontWeight: "bold" }}>
                      <strong>Final Amount : </strong> ₹
                      {orderDetails.final_amount ?? "N/A"}
                    </p>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <p>Unable to load order details.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

function OrderSection({ title, orders, variant, handleViewDetails }) {
  return (
    <Card className="shadow-xl h-100 wi">
      <Card.Header as="h5" className={`bg-${variant} text-white`}>
        {title}
      </Card.Header>
      <Card.Body style={{ maxHeight: "500px", overflowX: "auto" }}>
        {orders.length === 0 ? (
          <p className="text-muted">No {title.toLowerCase()}.</p>
        ) : (
          <Table striped bordered hover responsive className="mb-2">
            <thead className="table-light small text-center">
              <tr>
                <th>Date</th> {/* New column for Date */}
                <th>Order ID</th>
                <th>Total Price</th>
                <th>View</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => (
                <tr key={index}>
                  <td>
                    {order.latest_date ? (
                      <>
                        <div>
                          {order.latest_date
                            .split(" ")[0]
                            .split("-")
                            .reverse()
                            .join("-")}
                        </div>
                        <div>{order.latest_date.split(" ")[1]}</div>
                      </>
                    ) : (
                      "N/A"
                    )}
                  </td>

                  {/* Show order date here */}
                  <td className="td_highlight">{order.orderid}</td>
                  <td className="td_highlight">
                    ₹{order.total_price.toFixed(2)}
                  </td>
                  <td>
                    <a
                      href="#!"
                      onClick={(e) => {
                        e.preventDefault();
                        handleViewDetails(order);
                      }}
                    >
                      View Details
                    </a>
                  </td>
                  <td>
                    <Badge bg={variant}>{order.status}</Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
}
